import { useState } from "react";

import { useConvertBalances } from "@/entities/balance";
import { Modal } from "@/shared/ui/Modal";
import { Slider } from "@/shared/ui/slider";
import { Button } from "@/shared/ui/button";
import { useSessionStore } from "@/entities/session";
import { Spinner } from "@/shared/ui/spinner";

export const ConvertBalancesCard = () => {
  const { mutateAsync, isPending } = useConvertBalances();
  const { user } = useSessionStore();
  const [amount, setAmount] = useState([0]);
  const [open, setOpen] = useState(false);

  const FtBalance =
    user?.balances.find((b) => b.asset === "FT_COIN")?.balance || 0;

  const convertUsdToFt = (value: number) => {
    return value * 0.5;
  };

  const handleExchange = async () => {
    try {
      await mutateAsync({ amount: amount[0].toString() });
      setOpen(false);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal open={open} onOpenChange={setOpen}>
      <Modal.Trigger className="h-fit w-full">Конвертировать</Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Конвертировать FT коины</Modal.Title>

        <Slider
          value={amount}
          onValueChange={setAmount}
          min={0}
          max={FtBalance}
        />

        <p className="text-center text-lg font-semibold text-green-500">
          {amount[0]} FT = {convertUsdToFt(amount[0])}$
        </p>

        <Button disabled={amount[0] === 0} onClick={handleExchange}>
          {isPending ? <Spinner /> : "Конвертировать"}
        </Button>

        <p className="border-t pt-2 text-center text-textColor opacity-50">
          Курс: 1 FT = 0.5$
        </p>
      </Modal.Content>
    </Modal>
  );
};
